import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../contexts/LanguageContext";

const MARKET_IMG = "https://customer-assets.emergentagent.com/job_garnacha-nordic/artifacts/okfc4fkq_ChatGPT%20Image%2015%20jun%202026%2C%2023_29_32.png";

const About = () => {
  const { t } = useLang();

  return (
    <div data-testid="about-page" className="pt-32">
      {/* SINGLE EDITORIAL IMAGE — Mexican market, sets the entire mood */}
      <section className="container-pad pb-20">
        <div className="aspect-[16/9] w-full bg-[#F5EFE6] overflow-hidden">
          <img
            src={MARKET_IMG}
            alt="Mexican market"
            className="w-full h-full object-cover"
            style={{ filter: "grayscale(1) contrast(1.25) brightness(1.02)" }}
            data-testid="our-story-image"
          />
        </div>
      </section>

      {/* STORY */}
      <section className="container-pad py-20 sm:py-28">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-24">
          <div className="lg:col-span-5 lg:sticky lg:top-32 lg:self-start">
            <div className="eyebrow text-[#F97316]">{t.about.eyebrow}</div>
            <h2 className="display-serif mt-8 text-4xl sm:text-5xl lg:text-6xl leading-[1.02]">
              A word.<br /><span className="italic">A way of life.</span>
            </h2>
          </div>
          <div className="lg:col-span-7 lg:col-start-6 space-y-10 text-xl sm:text-2xl font-light leading-[1.6] text-foreground/80">
            <p data-testid="about-p1">{t.about.p1}</p>
            <p data-testid="about-p2">{t.about.p2}</p>
            <p data-testid="about-p3">{t.about.p3}</p>
            <p data-testid="about-p4">{t.about.p4}</p>
            <p data-testid="about-p5">
              <span className="text-[#F97316]">{t.about.pull1} {t.about.pull2}</span> {t.about.closing}
            </p>
          </div>
        </div>
      </section>

      {/* MISSION & VISION */}
      <section className="border-t border-border" data-testid="mission-vision">
        <div className="container-pad py-24 sm:py-32">
          <div className="grid lg:grid-cols-2 gap-16 lg:gap-24">
            <div data-testid="mission-block">
              <div className="eyebrow text-[#F97316]">{t.about.missionEyebrow}</div>
              <p className="display-serif mt-6 text-3xl sm:text-4xl lg:text-5xl leading-[1.15]">
                {t.about.mission}
              </p>
            </div>
            <div data-testid="vision-block">
              <div className="eyebrow text-[#F97316]">{t.about.visionEyebrow}</div>
              <p className="display-serif mt-6 text-3xl sm:text-4xl lg:text-5xl leading-[1.15]">
                {t.about.vision}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* FOOTER STATEMENT */}
      <section className="container-pad pb-32" data-testid="footer-statement">
        <div className="text-center pt-16">
          <div className="display-serif text-4xl sm:text-5xl lg:text-6xl">{t.about.tagline1}</div>
          <div className="display-serif text-4xl sm:text-5xl lg:text-6xl italic text-[#F97316]">{t.about.tagline2}</div>
        </div>
      </section>

      <section className="bg-[#F97316] text-[#FFF8F0] py-24 text-center" data-testid="about-cta">
        <h2 className="display-serif text-4xl sm:text-5xl lg:text-6xl">Taste it for yourself.</h2>
        <div className="mt-10 flex justify-center gap-4 flex-wrap container-pad">
          <Link to="/products" data-testid="about-cta-products" className="btn-pill bg-[#FFF8F0] text-[#222] hover:bg-[#222] hover:text-[#FFF8F0]">{t.common.exploreProducts}</Link>
          <Link to="/contact" data-testid="about-cta-contact" className="btn-ghost-light">{t.common.contactUs}</Link>
        </div>
      </section>
    </div>
  );
};

export default About;
